window.VariationsWidget ?= {}
VariationsWidget.Views ?= {}

VariationsWidget.Views.Option = require './option'

VariationsWidget.Views.OptionCollection = Backbone.View.extend
  events:
    "change" : "selectionChanged"

  initialize: ->
    _.bindAll this, 'selectionChanged', 'render'
    @optionElementViews = for optionElementModel in @collection.models
      new VariationsWidget.Views.Option
        el: "#trait-"+optionElementModel.get('traitIndex')+"-"+optionElementModel.get('id')
        model: optionElementModel

  render: ->
    for optionElementView in @optionElementViews
      optionElementView.render()

  isSelectedOptionDisabled: (selectElement) ->
    selectElement?.options[selectElement.selectedIndex].disabled

  selectionChanged: (e) ->
    $currentElement = $(e.currentTarget)[0]
    if VariationsWidget.controller.ie7 && @isSelectedOptionDisabled $currentElement
      $currentElement.selectedIndex = 0

    value = $(e.currentTarget).val()
    model = @collection.chosen value
    VariationsWidget.controller.render
      trait: @collection.models[0].get('traitName')
      selection: value
      id: model.get('id')

VariationsWidget.Views.OptionCollection.create = (collections) ->
  for trait, index in collections
    new VariationsWidget.Views.OptionCollection
      collection: trait
      el: "#trait-"+index


module.exports = VariationsWidget.Views.OptionCollection
